import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$ADJUST_OPEN_PURCHASE_CHOICE/REQUESTED';
const BLOCKED = '$ADJUST_OPEN_PURCHASE_CHOICE/BLOCKED';
const APPROVED = '$ADJUST_OPEN_PURCHASE_CHOICE/APPROVED';
const SUCCEEDED = '$ADJUST_OPEN_PURCHASE_CHOICE/SUCCEEDED';
const FAILED = '$ADJUST_OPEN_PURCHASE_CHOICE/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      targetChoiceSetId: string;
      targetChoiceId?: string;
      clear?: boolean;
    }>(type);
};

const succeed = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      purchase: _Purchase;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, succeed),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
